module.exports = __webpack_public_path__ + "img/couples_05_V.1d659d3d.jpg";